import React, { useState } from 'react'
import classnames from "classnames"
import _ from "lodash"
import { UncontrolledDropdown, DropdownMenu, DropdownItem, Badge } from 'reactstrap'
import { CheckSquare, Bell } from 'react-feather'
//************************************//
import { ActionDropdownToggle } from "@src/components/datatable"
import { trans } from "@utils"
//************************************//
import TypesModal from "./TypesModal"
import { CustomFieldTypes } from "../../../assets/data/constants"
import DeleteModal from "../DeleteModal"
//************************************//

const DragWrapper = props => {
  const { provided, children, dataState } = props
  const { entityCustomFieldItem, customFieldsState } = dataState
  const { customFields, setCustomFields } = customFieldsState

  const [deleteModalShow, setDeleteModalShow] = useState(false)

  const onDelete = async () => {
    await setCustomFields(prevState => {
      let unusedCustomFieldsList = prevState.unusedCustomFieldsList
      if (!_.startsWith(entityCustomFieldItem.key, 'new_')) {
        unusedCustomFieldsList = [
          ...prevState.unusedCustomFieldsList,
          entityCustomFieldItem
        ]
      }
      return {
        ...prevState,
        unusedCustomFieldsList,
        entityCustomFieldsList: _.filter(prevState.entityCustomFieldsList, x => x.key !== entityCustomFieldItem.key)
      }
    })
  }

  return (
    <div
      className={classnames('entity-custom-field-draggable-row bg-white my-50')}
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
    >
      <div
        className={classnames('shadow-sm border-left-3 entity-custom-field-item-row d-flex cursor-pointer px-50 py-25 align-items-center position-relative', {
          'border-left-danger': entityCustomFieldItem.is_required,
          'border-left-white': !entityCustomFieldItem.is_required
        })}
      >
        <div className={'d-flex w-50 flex-column'}>
          <span className={classnames('ml-1', {
            "text-warning": _.startsWith(entityCustomFieldItem.key, "new_")
          })}>
            {_.get(entityCustomFieldItem, 'name')}
          </span>
        </div>
        <div className={'d-flex justify-content-between w-50 align-items-center'}>
          <span className={'text-muted px-1'}>
            {/* Unknown field types fall back to the raw type so the row still renders. */}
            {CustomFieldTypes[_.get(entityCustomFieldItem, 'field_type')]
              ? trans(CustomFieldTypes[_.get(entityCustomFieldItem, 'field_type')].label)
              : _.get(entityCustomFieldItem, 'field_type')}
          </span>
          <UncontrolledDropdown>
            <ActionDropdownToggle />
            <DropdownMenu right>
              <DropdownItem className='w-100' onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                setCustomFields(prevState => {
                  _.find(prevState.entityCustomFieldsList, x => x.key === entityCustomFieldItem.key).is_required = !entityCustomFieldItem.is_required
                  return {
                    ...prevState,
                    entityCustomFieldsList: prevState.entityCustomFieldsList,
                    refresh: !prevState.refresh
                  }
                })
              }}>
                <div className={'d-flex justify-content-center align-items-center'}>
                  {
                    entityCustomFieldItem.is_required ? (
                      <CheckSquare className={'icon-primary'} size={12} />
                    ) : (
                      <div style={{ width: 12 }} />
                    )
                  }
                  <span className={'ml-50 mr-75'}>{trans('customFields.markAsRequired')}</span>
                </div>
              </DropdownItem>
              <DropdownItem className='w-100' onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                setCustomFields(prevState => ({
                  ...prevState,
                  editItemModal: {
                    data: entityCustomFieldItem
                  }
                }))
              }}>
                <div className={'d-flex align-items-center'}>
                  <div style={{ width: 12 }}></div>
                  <span className={'ml-50 mr-75'}>{trans('customFields.editProperties')}</span>
                </div>
              </DropdownItem>
              <DropdownItem className='w-100 btn-flat-danger' onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                setDeleteModalShow(true)
              }}>
                <div className={'d-flex align-items-center'}>
                  <div style={{ width: 12 }}></div>
                  <span className={'ml-50 mr-75'}>{trans('customFields.removeFields')}</span>
                </div>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </div>
      {
        entityCustomFieldItem.key === customFields?.editItemModal?.data?.key && (
          <TypesModal {...props}>
            {children}
          </TypesModal>
        )
      }
      {
        deleteModalShow && (
          <DeleteModal
            data={{
              title: trans('customFields.removeFieldTitle', { name: entityCustomFieldItem.name }),
              text: trans('customFields.removeFieldText'),
              subText: trans('customFields.removeFieldSubText'),
              denyButtonText: trans('gen.yesNo.no'),
              confirmButtonText: trans('customFields.removeButtonText')
            }}
            onClose={() => setDeleteModalShow(false)}
            onDelete={onDelete}
          />
        )
      }
    </div>
  )
}

DragWrapper.propTypes = {}

export default DragWrapper